module.exports = require("./fr-MQ");